module.exports = __webpack_public_path__ + "static/media/icn-execute.0eeb73e9.svg";